// extracted by mini-css-extract-plugin
export var loadingSpinner = "_20-0";